import React, { useState, useEffect } from "react";
import { Loader2, X, AlertCircle, CheckCircle2 } from "lucide-react";
import axios from "axios";
import CalendarInput from "../calendarInput";
import { useLocation } from "react-router-dom";


const BASE_URL = process.env.REACT_APP_BASE_URL;

const HandleExit = ({
  showExitModal,
  hasPayoutGen,
  hasPayoutApproval,
     selectedStatus,
  setShowExitModal,
  selectedRecord,  
  selectedCompany,
  isUTVMember,
  currentPage,
  fetchAttendanceData,
}) => {
  const isUTV = isUTVMember ? "true" : "false";

  // Destructure for easy access
  const workerData = selectedRecord?.data || null;
  const attendance = selectedRecord?.attendance || null;

  const [exitDate, setExitDate] = useState("");
  const [timeInput, setTimeInput] = useState({ hours: "", minutes: "", period: "PM" });
  const [busExit, setBusExit] = useState(false);
  const [haveFood, setHaveFood] = useState(false);
  const [takenApron, setTakenApron] = useState(false);
  const [initialTakenApron, setInitialTakenApron] = useState(false);
  const [isApronModified, setIsApronModified] = useState(false);
  const [exitTimeError, setExitTimeError] = useState("");

  // Department
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [isDeptOpen1, setIsDeptOpen1] = useState(false);
  // FIX: store full department objects for _id lookup in handleDepartmentUpdate
  const [modalDepartmentsData, setModalDepartmentsData] = useState([]);

  // UTV: modal location/company
  const [modalLocations, setModalLocations] = useState([]);
  const [selectedModalLocation, setSelectedModalLocation] = useState("");
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [modalCompanies, setModalCompanies] = useState([]);
  const [selectedModalCompany, setSelectedModalCompany] = useState("");
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  const [loadingModalCompanies, setLoadingModalCompanies] = useState(false);

  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const path = window.location.pathname;


let editInsidePayoutFileBy;

if (selectedStatus=="Payout Generator") {
  editInsidePayoutFileBy = "file_generator";
} else if (selectedStatus="Payout Approver") {
  editInsidePayoutFileBy = "file_Approver";
}

  // Pre-fill on open
  useEffect(() => {
    if (!showExitModal || !attendance) return;

    const init = async () => {
      setSelectedModalLocation("");
      setSelectedModalCompany("");
      setModalCompanies([]);
      setDepartments([]);
      setModalDepartmentsData([]);
      setSelectedDepartment("");
      // FIX: read isModified from attendance to match original's record.isModified
      setIsApronModified(attendance.isModified || false);

      // Pre-fill exitDate from attendance.ExitDate, fallback to attendance.EntryDate
      if (attendance.ExitDate) {
        setExitDate(attendance.ExitDate.split("T")[0]);
      } else if (attendance.EntryDate) {
        setExitDate(attendance.EntryDate.split("T")[0]);
      }

      // Pre-fill exit time from attendance.ExitDate
      if (attendance.ExitDate) {
        const timePart = attendance.ExitDate.split("T")[1]?.split(".")[0];
        if (timePart) {
          const [hours, minutes] = timePart.split(":");
          let hourNum = parseInt(hours);
          const period = hourNum >= 12 ? "PM" : "AM";
          if (hourNum > 12) hourNum -= 12;
          else if (hourNum === 0) hourNum = 12;
          setTimeInput({ hours: hourNum.toString(), minutes, period });
        }
      } else {
        setTimeInput({ hours: "", minutes: "", period: "PM" });
      }

      setBusExit(attendance.busExit || false);
      // FIX: check both haveFood and hadFood to match original (record.haveFood || record.hadFood)
      setHaveFood(attendance.haveFood || attendance.hadFood || false);
      setTakenApron(attendance.takenApron || false);
      setInitialTakenApron(attendance.takenApron || false);
      setExitTimeError("");

      try {
        const token = path.startsWith("/lkart/admin")
  ? localStorage.getItem("admin_auth_token")
  : path.startsWith("/lkart/superadmin")
    ? localStorage.getItem("superadmintoken")
    : null;
        if (isUTV !== "true") {
          // Non-UTV: fetch departments for the selected company
          const response = await axios.post(
            `${BASE_URL}/onDemandCompanies/list-departments`,
            { companyId: selectedCompany },
            { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
          );
          if (response.data.success && Array.isArray(response.data.departments)) {
            const departmentNames = response.data.departments
              .map((d) => d.department)
              .filter((d) => d && d !== "All");
            setDepartments(departmentNames);
            // FIX: store full dept objects for ID lookup
            setModalDepartmentsData(response.data.departments);
            setSelectedDepartment(attendance.department || "");
          }
        } else {
          // UTV: fetch locations list for the modal dropdowns
          const locationResponse = await axios.get(`${BASE_URL}/lenskart/locations`, {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          });
          if (locationResponse.data.success && Array.isArray(locationResponse.data.locations)) {
            setModalLocations(locationResponse.data.locations);
          }
        }
      } catch (error) {
        console.error("Error in HandleExit init:", error);
      }
    };

    init();
  }, [showExitModal, attendance, selectedCompany, isUTV]);

  const convertTo24HourWithSeconds = (hours, minutes, period) => {
    let hourNum = parseInt(hours);
    if (period === "AM" && hourNum === 12) hourNum = 0;
    else if (period === "PM" && hourNum !== 12) hourNum += 12;
    return `${hourNum.toString().padStart(2, "0")}:${minutes.padStart(2, "0")}:00`;
  };

  const closeModal = () => {
    setShowExitModal(false);
    setBusExit(false);
    setHaveFood(false);
    setTakenApron(false);
    setIsApronModified(false);
    setSelectedModalLocation("");
    setSelectedModalCompany("");
    setModalLocations([]);
    setModalCompanies([]);
    setModalDepartmentsData([]);
    setIsLocationModalOpen(false);
    setIsCompanyModalOpen(false);
    if (isUTV === "true") {
      setDepartments([]);
      setSelectedDepartment("");
    }
  };

  const handleTimeChange = (e) => {
    const { name, value } = e.target;
    if (name === "hours" && value !== "") {
      const num = parseInt(value);
      if (isNaN(num) || num < 1 || num > 12) return;
    }
    if (name === "minutes" && value !== "") {
      const num = parseInt(value);
      if (isNaN(num) || num < 0 || num > 59) return;
    }
    setTimeInput((prev) => ({ ...prev, [name]: value }));
    if (exitTimeError) setExitTimeError("");
  };

  const handleExitDateChange = (value) => {
    setExitDate(value);
    if (exitTimeError) setExitTimeError("");
  };

  const handleApronChange = (e) => {
    setTakenApron(e.target.checked);
    setIsApronModified(true);
  };

  const validateExitDateTime = () => {
    if (!attendance || !exitDate || !timeInput.hours || !timeInput.minutes) return false;

    const entryDateTime = new Date(attendance.EntryDate);
    const time24h = convertTo24HourWithSeconds(
      timeInput.hours, timeInput.minutes.padStart(2, "0"), timeInput.period
    );
    const exitDateTime = new Date(`${exitDate}T${time24h}.000Z`);

    if (exitDateTime <= entryDateTime) {
      setExitTimeError("Exit time must be after entry time");
      return false;
    }
    const diffInHours = (exitDateTime - entryDateTime) / (1000 * 60 * 60);
    if (diffInHours > 14) {
      setExitTimeError("Exit time cannot be more than 14 hours after entry time");
      return false;
    }
    setExitTimeError("");
    return true;
  };

  // FIX: pass location._id (not the full object) to the companies endpoint
  const fetchModalCompanies = async (locationId) => {
    if (!locationId) { setModalCompanies([]); setSelectedModalCompany(""); return; }
    try {
      setLoadingModalCompanies(true);
      const token = path.startsWith("/lkart/admin")
  ? localStorage.getItem("admin_auth_token")
  : path.startsWith("/lkart/superadmin")
    ? localStorage.getItem("superadmintoken")
    : null;
      const response = await axios.get(
        `${BASE_URL}/onDemandCompanies/list-companies/${locationId}`,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      if (response.data && Array.isArray(response.data.companies)) {
        setModalCompanies(response.data.companies);
      } else {
        setModalCompanies([]);
      }
    } catch { setModalCompanies([]); }
    finally { setLoadingModalCompanies(false); }
  };

  // FIX: store full dept objects in modalDepartmentsData for _id lookup
  const fetchModalDepartments = async (companyId) => {
    if (!companyId) { setDepartments([]); setModalDepartmentsData([]); setSelectedDepartment(""); return; }
    try {
     const token = path.startsWith("/lkart/admin")
  ? localStorage.getItem("admin_auth_token")
  : path.startsWith("/lkart/superadmin")
    ? localStorage.getItem("superadmintoken")
    : null;
      const response = await axios.post(
        `${BASE_URL}/onDemandCompanies/list-departments`,
        { companyId },
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      if (response.data && Array.isArray(response.data.departments)) {
        const departmentNames = response.data.departments
          .map((d) => d.department)
          .filter((d) => d && d !== "All");
        setDepartments(departmentNames);
        // FIX: store full objects for _id lookup in handleDepartmentUpdate
        setModalDepartmentsData(response.data.departments);
      } else {
        setDepartments([]);
        setModalDepartmentsData([]);
      }
    } catch {
      setDepartments([]);
      setModalDepartmentsData([]);
    }
  };

  // FIX: also send departmentId looked up from modalDepartmentsData — matches original exactly
  const handleDepartmentUpdate = async () => {
    if (!selectedDepartment) {
      setErrorMessage("Please select a department"); setShowErrorModal(true); return;
    }
    try {
      setLoading(true);
      const token = path.startsWith("/lkart/admin")
  ? localStorage.getItem("admin_auth_token")
  : path.startsWith("/lkart/superadmin")
    ? localStorage.getItem("superadmintoken")
    : null;
      const response = await axios.post(
        `${BASE_URL}/lenskart-admin/update-department`,
        {
          attendanceId: attendance._id,
          department: selectedDepartment,
          // FIX: look up _id from modalDepartmentsData for both UTV and non-UTV
          departmentId: modalDepartmentsData.find((d) => d.department === selectedDepartment)?._id,
          companyId: isUTV === "true" ? selectedModalCompany : selectedCompany,
          ...(isPayoutFilePage && { editInsidePayoutFile: true ,editInsidePayoutFileBy})
        },
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
if (response.data.success) {
  setErrorMessage("Department has been updated successfully");
  setShowSuccessModal(true);
fetchAttendanceData(currentPage, false);
}else {
        setErrorMessage(response.data.message || "Failed to update department");
        setShowErrorModal(true);
      }
      
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Error updating department. Please try again.");
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

const location = useLocation();

const params = new URLSearchParams(location.search);

const isPayoutFilePage =
  location.pathname === "/lkart/superadmin/payout-file" &&
  params.has("id");

  const handleExitSubmit = async () => {
    if (!timeInput.hours || !timeInput.minutes) {
      setErrorMessage("Please enter both hours and minutes"); setShowErrorModal(true); return;
    }
    if (!exitDate) {
      setErrorMessage("Please select an exit date"); setShowErrorModal(true); return;
    }
    if (!validateExitDateTime()) return;

    try {
      setLoading(true);
      const token = path.startsWith("/lkart/admin")
  ? localStorage.getItem("admin_auth_token")
  : path.startsWith("/lkart/superadmin")
    ? localStorage.getItem("superadmintoken")
    : null;
      const time24h = convertTo24HourWithSeconds(
        timeInput.hours, timeInput.minutes.padStart(2, "0"), timeInput.period
      );
      const exitDateTime = new Date(`${exitDate}T${time24h}.000Z`).toISOString();

      const payload = {
        userId: workerData._id,
        attendanceId: attendance._id,
        date: exitDate,
        status: "exit",
        exitTime: exitDateTime,
        busExit,
        haveFood,
        companyId: selectedCompany,
        ...(isPayoutFilePage && { editInsidePayoutFile: true ,editInsidePayoutFileBy })
      };
      // Only send takenApron if user manually modified it
      if (isApronModified) payload.takenApron = takenApron;

      const response = await axios.post(
        `${BASE_URL}/lenskart-admin/mark-entry-exit`,
        payload,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
if (response.data.success) {
  setErrorMessage("Exit time has been marked successfully");
  setShowSuccessModal(true);
  closeModal();
fetchAttendanceData(currentPage, false);
}else {
        setErrorMessage(response.data.message || "Failed to record exit time");
        setShowErrorModal(true);
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Error recording exit time. Please try again.");
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Exit Modal */}
      {showExitModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold">Mark Exit Time</h3>
              <X className="h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-700" onClick={closeModal} />
            </div>

            {loading ? (
              <div className="flex justify-center items-center py-8">
                <Loader2 className="h-8 w-8 animate-spin" />
              </div>
            ) : (
              <div className="mb-6">
                <p className="text-sm text-gray-600 mb-1">
                  Worker Name: <span className="font-medium">{workerData?.name}</span>
                </p>
                {workerData?.workerCode && (
  <p className="text-sm text-gray-600 mb-4">
    Worker Code: <span className="font-medium">{workerData.workerCode}</span>
  </p>
)}

                {/* UTV: Location + Company dropdowns */}
                {isUTV === "true" && (
                  <>
                    {/* Location */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Location <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <button
                          onClick={() => setIsLocationModalOpen(!isLocationModalOpen)}
                          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md text-left flex justify-between items-center bg-white"
                        >
                          {/* FIX: resolve name from modalLocations array using _id */}
                          {modalLocations.find((l) => l._id === selectedModalLocation)?.name || "Select Location"}
                          <svg className={`h-4 w-4 transform transition-transform ${isLocationModalOpen ? "rotate-180" : ""}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                          </svg>
                        </button>
                        {isLocationModalOpen && (
                          <div className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded-md py-1 max-h-48 overflow-auto border border-gray-300">
                            {modalLocations.map((location, index) => (
                              <button
                                key={index}
                                onClick={() => {
                                  // FIX: store location._id (not the full object)
                                  setSelectedModalLocation(location._id);
                                  setIsLocationModalOpen(false);
                                  setSelectedModalCompany("");
                                  setModalCompanies([]);
                                  setSelectedDepartment("");
                                  setDepartments([]);
                                  setModalDepartmentsData([]);
                                  // FIX: pass location._id to fetchModalCompanies
                                  fetchModalCompanies(location._id);
                                }}
                                className={`block w-full text-left px-4 py-2 text-sm hover:bg-indigo-100 ${selectedModalLocation === location._id ? "bg-indigo-50 text-indigo-700" : "text-gray-700"}`}
                              >
                                {location.name}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Company */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Company <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <button
                          onClick={() => { if (selectedModalLocation && !loadingModalCompanies) setIsCompanyModalOpen(!isCompanyModalOpen); }}
                          disabled={!selectedModalLocation || loadingModalCompanies}
                          className={`w-full px-3 py-2 text-sm border border-gray-300 rounded-md text-left flex justify-between items-center ${!selectedModalLocation || loadingModalCompanies ? "bg-gray-100 cursor-not-allowed text-gray-400" : "bg-white"}`}
                        >
                          {loadingModalCompanies ? (
                            <span className="flex items-center"><Loader2 className="h-3 w-3 animate-spin mr-2" />Loading...</span>
                          ) : selectedModalCompany ? (
                            modalCompanies.find((c) => c._id === selectedModalCompany)?.name || "Select Company"
                          ) : "Select Company"}
                          <svg className={`h-4 w-4 transform transition-transform ${isCompanyModalOpen ? "rotate-180" : ""} ${!selectedModalLocation || loadingModalCompanies ? "text-gray-400" : ""}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                          </svg>
                        </button>
                        {isCompanyModalOpen && selectedModalLocation && !loadingModalCompanies && (
                          <div className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded-md py-1 max-h-48 overflow-auto border border-gray-300">
                            {modalCompanies.length > 0 ? modalCompanies.map((company) => (
                              <button
                                key={company._id}
                                onClick={() => {
                                  setSelectedModalCompany(company._id);
                                  setIsCompanyModalOpen(false);
                                  setSelectedDepartment("");
                                  setModalDepartmentsData([]);
                                  fetchModalDepartments(company._id);
                                }}
                                className={`block w-full text-left px-4 py-2 text-sm hover:bg-indigo-100 ${selectedModalCompany === company._id ? "bg-indigo-50 text-indigo-700" : "text-gray-700"}`}
                              >
                                {company.name}
                              </button>
                            )) : (
                              <div className="px-4 py-2 text-sm text-gray-500">No companies found for this location</div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {/* Department */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Department</label>
                  <div className="flex gap-2">
                    <div className="relative flex-1">
                      <button
                        onClick={() => { if (isUTV === "true" ? selectedModalCompany : true) setIsDeptOpen1(!isDeptOpen1); }}
                        disabled={isUTV === "true" && !selectedModalCompany}
                        className={`w-full px-3 py-2 text-sm border border-gray-300 rounded-md text-left flex justify-between items-center ${isUTV === "true" && !selectedModalCompany ? "bg-gray-100 cursor-not-allowed text-gray-400" : "bg-white"}`}
                      >
                        {selectedDepartment || "Select Department"}
                        <svg className={`h-4 w-4 transform transition-transform ${isDeptOpen1 ? "rotate-180" : ""} ${isUTV === "true" && !selectedModalCompany ? "text-gray-400" : ""}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button>
                      {isDeptOpen1 && (
                        <div className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded-md py-1 max-h-48 overflow-auto border border-gray-300">
                          {departments.map((dept, index) => (
                            <button
                              key={index}
                              onClick={() => { setSelectedDepartment(dept); setIsDeptOpen1(false); }}
                              className={`block w-full text-left px-4 py-2 text-sm hover:bg-indigo-100 ${selectedDepartment === dept ? "bg-indigo-50 text-indigo-700" : "text-gray-700"}`}
                            >
                              {dept}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <button
                    onClick={handleDepartmentUpdate}
                    disabled={loading || !selectedDepartment || (isUTV === "true" && !selectedModalCompany)}
                    className="mt-4 px-3 py-2 bg-indigo-600 text-white text-sm rounded-md hover:bg-indigo-700 disabled:bg-indigo-300 disabled:cursor-not-allowed"
                  >
                    Update Department
                  </button>
                </div>

                {/* Exit Date */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Exit Date</label>
                  <CalendarInput value={exitDate} onChange={handleExitDateChange} />
                </div>

                {/* Exit Time */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Exit Time</label>
                  <div className="flex items-center gap-2">
                    <input type="number" name="hours" value={timeInput.hours} onChange={handleTimeChange}
                      placeholder="HH" min="1" max="12" className="w-16 px-3 py-2 border border-gray-300 rounded-md text-center" />
                    <span>:</span>
                    <input type="number" name="minutes" value={timeInput.minutes} onChange={handleTimeChange}
                      placeholder="MM" min="0" max="59" className="w-16 px-3 py-2 border border-gray-300 rounded-md text-center" />
                    <select name="period" value={timeInput.period} onChange={handleTimeChange}
                      className="w-20 px-2 py-2 border border-gray-300 rounded-md">
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>

                {/* Bus Exit */}
                <div className="flex items-start mb-3">
                  <input type="checkbox" id="busExit" checked={busExit} onChange={(e) => setBusExit(e.target.checked)}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded mt-1" />
                  <label htmlFor="busExit" className="ml-2 block text-sm text-gray-700">Taken Factorykaam Bus Service</label>
                </div>

                {/* Food */}
                <div className="flex items-start mb-3">
                  <input type="checkbox" id="haveFood" checked={haveFood} onChange={(e) => setHaveFood(e.target.checked)}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded mt-1" />
                  <label htmlFor="haveFood" className="ml-2 block text-sm text-gray-700">Availed Food in Factory</label>
                </div>

                {/* Apron */}
                {/* {takenApron && !isApronModified ? (
                  <div className="text-sm text-green-600 font-medium mb-4">Apron Taken from Factory</div>
                ) : (
                  <div className="flex items-start mb-4">
                    <input type="checkbox" id="takenApron" checked={takenApron} onChange={handleApronChange}
                      className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded mt-1" />
                    <label htmlFor="takenApron" className="ml-2 block text-sm text-gray-700">Taken Apron from Factory</label>
                  </div>
                )} */}

                {exitTimeError && (
                  <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded-md mb-4">
                    <div className="flex items-center">
                      <AlertCircle className="h-4 w-4 mr-2 flex-shrink-0" />
                      <span className="text-sm">{exitTimeError}</span>
                    </div>
                  </div>
                )}

                <button
                  onClick={handleExitSubmit}
                  disabled={loading || !timeInput.hours || !timeInput.minutes || !exitDate}
                  className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-indigo-300 flex items-center justify-center"
                >
                  {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Mark Exit Time"}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Success Modal — outside showExitModal gate so it persists after modal closes */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1100]">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
            <div className="flex flex-col items-center text-center">
              <CheckCircle2 className="h-12 w-12 text-green-500 mb-4" />
              <h3 className="text-lg font-semibold mb-2">Success!</h3>
              <p className="text-gray-600 mb-6">{errorMessage}</p>
              <button onClick={() => setShowSuccessModal(false)} className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">OK</button>
            </div>
          </div>
        </div>
      )}

      {/* Error Modal — outside showExitModal gate so it persists after modal closes */}
      {showErrorModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1100]">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
            <div className="flex flex-col items-center text-center">
              <AlertCircle className="h-12 w-12 text-red-500 mb-4" />
              <h3 className="text-lg font-semibold mb-2">Error</h3>
              <p className="text-gray-600 mb-6">{errorMessage}</p>
              <button onClick={() => setShowErrorModal(false)} className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">OK</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HandleExit;